import React from 'react';

const OurVision = () => {
  return (
    <section className="our-vision-area ptb-100 pt-0">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="single-vision-box">
              <div className="icon">
                <i className="icofont-tick-mark"></i>
              </div>
              <h3>Our Mission</h3>
              <p>
              We are on a mission to constantly improve our services and bring excellence every single day
and become the first choice of each and every patient who is looking for the Wallabies Forced
Air Patient Warming Blanket. Our medical equipment improves the lives of those people who
are looking for compassionate and responsive healthcare solutions. When you are active in the
healthcare segment then the one and only mission that you always have at the back of your
mind is the complete care of each and every patient who came across in your journey.
Having a sophisticated job of providing warming services we understand our responsibility very
well and our one and only mission is to improve the lives of all those people who are looking for
our services. We constantly bring innovative ideas to provide premium quality and life-
enhancing medical devices in different parts of the world. We are one of the most trusted
designing and manufacturing units in the industry which have ample manpower and resources
to fulfill the constantly increasing demands of the modern healthcare industry. We all know that
as time progresses the complexity is increasing in the medical profession; now patients need
more sophisticated and critical care to recover from surgeries and for that our Wallabies
Forced Air Patient Warming Unit plays a significant role to provide a comprehensive solution.
              </p>
            </div>
          </div>
          {/* <div className="col-lg-4 col-md-6 col-12">
            <div className="single-vision-box">
              <div className="icon">
                <i className="icofont-tick-mark"></i>
              </div>
              <h3>Our Planning</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis
                ipsum suspendisse.
              </p>
            </div>
          </div> */}
          <div className="col-lg-6 col-md-6 col-12">
            <div className="single-vision-box">
              <div className="icon">
                <i className="icofont-tick-mark"></i>
              </div>
              <h3>Our Vision</h3>
              {/* <p>
              When you are active in the field of health care then you have only one vision in mind which is to
serve society. We just want to focus on how we can help as many people as possible.
WALLABIES is moving ahead with the sole vision to provide comprehensive warming systems.
We want to become a global innovation leader in the segment of forced air warming medical
services.
We want to grow and develop our business by providing such products which are safe and
effective and able to fulfill the expectations of new edge surgeons as well as ensure better
caretaking of the patients. The core values of our company lie in-
● Accountability
● Honesty
● Integrity
● and high business ethics
Here all the employees work together as a team; where we support and improve each other
without following any strict hierarchical model to make the company&#39;s operation smooth and
handle different departments with great efficiency. We are a bunch of highly enthusiastic and
dedicated teammates who enjoy each other&#39;s company and consider each other like family
members. We want to establish ourselves as a global leader in air-warming services and
wanted to ensure that we would be able to support the patients in some way or another.
Our vision is completely based on trust, transparency and honest services. We are always
ready to take new risks and adapt ourselves to the changing environment and demands of the
clients. We learn from our mistakes and keep moving ahead without losing enthusiasm; this
approach towards the business is the main reason behind our success so far and we hope that
in future as well we will emerge as winners with our honest efforts.
              </p> */}
                 <div className="company-vision">
      <p>
        When you are active in the field of health care, you have only one vision in mind, which is to serve society. We just want to focus on how we can help as many people as possible. 
        WALLABIES is moving ahead with the sole vision to provide comprehensive warming systems. We want to become a global innovation leader in the segment of forced air warming medical services. 
        We want to grow and develop our business by providing such products that are safe and effective and able to fulfill the expectations of new-age surgeons as well as ensure better caretaking of the patients. 
        The core values of our company lie in:
      </p>
      <ul className="core-values">
        <li>Accountability</li>
        <li>Honesty</li>
        <li>Integrity</li>
        <li>High business ethics</li>
      </ul>
      <p>
        Here, all the employees work together as a team, where we support and improve each other without following any strict hierarchical model to make the company’s operation smooth and handle different departments with great efficiency. 
        We are a bunch of highly enthusiastic and dedicated teammates who enjoy each other’s company and consider each other like family members. We want to establish ourselves as a global leader in air-warming services and ensure that we will be able to support the patients in some way or another.
      </p>
      <p>
        Our vision is completely based on trust, transparency, and honest services. We are always ready to take new risks and adapt ourselves to the changing environment and demands of the clients. We learn from our mistakes and keep moving ahead without losing enthusiasm. 
        This approach towards the business is the main reason behind our success so far, and we hope that in the future, as well, we will emerge as winners with our honest efforts.
      </p>
    </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurVision;
